export const cities = [
  {
    name: "San Francisco",
    country: "USA",
    coordinates: [-122.4194, 37.7749],
    dates: "2022–2023, 2025–2026",
    description:
      "This is the city I called home for the last four years, and I got to see its different vibes, from engaging with the Muslim community at the mosque, to tutoring students at 826 Valencia, to getting involved at City Hall.",
    photos: ["/images/around-the-world/San Francisco (1).jpg"],
  },
  {
    name: "Seoul",
    country: "South Korea",
    coordinates: [126.978, 37.5665],
    dates: "2023",
    description:
      "In my semester in Seoul, I visited Jeju Island and reached the summit of Hallasan, the highest mountain in South Korea.",
    photos: ["/images/around-the-world/seoul.jpg"],
  },
  {
    name: "Buenos Aires",
    country: "Argentina",
    coordinates: [-58.3816, -34.6037],
    dates: "2024",
    description:
      "Immersed in the vibrant culture of Buenos Aires while continuing coursework and exploring South America.",
    photos: ["/images/around-the-world/Argentina.jpg"],
  },
  {
    name: "Berlin",
    country: "Germany",
    coordinates: [13.405, 52.52],
    dates: "2024",
    description:
      "Studied in Berlin, a city at the crossroads of history, art, and cutting-edge technology.",
    photos: ["/images/around-the-world/Berlin.jpg"],
  },
  {
    name: "Egypt",
    country: "Egypt",
    coordinates: [31.2357, 30.0444],
    dates: "Home",
    description:
      "I grew up in a small city two hours from Cairo, in a community that was kind and supportive. My younger self always dreamed of taking an extraordinary journey, and that journey is just getting started.",
    photos: ["/images/around-the-world/Egypt.jpg"],
  },
  {
    name: "Saudi Arabia",
    country: "Saudi Arabia",
    coordinates: [46.6753, 24.7136],
    dates: "Visited",
    description:
      "As a Muslim, Saudi Arabia, specifically Makkah, carries deep significance as the home of Masjid Al-Haram (The Grand Mosque). I have been blessed to visit multiple times to perform Umrah.",
    photos: ["/images/around-the-world/Saudi Arabia.jpg"],
  },
  {
    name: "Paris",
    country: "France",
    coordinates: [2.3522, 48.8566],
    dates: "Visited",
    description:
      "In just six hours, my roommate and I navigated Paris's public transport and toured the city from the Arc de Triomphe to the Eiffel Tower and, most importantly, tried the best French croissant.",
    photos: ["/images/around-the-world/Paris.jpg"],
  },
  {
    name: "Brussels",
    country: "Belgium",
    coordinates: [4.3517, 50.8503],
    dates: "Visited",
    description:
      "I visited the European Parliament with a group of classmates and got to hear from Danish and German representatives, discussing the EU's progress in technology and sustainability.",
    photos: ["/images/around-the-world/brussels.jpg"],
  },
];
